const COMP = ({ ...props }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10.3367" cy="10.1653" r="10" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.42302 14.8686C4.00375 14.6123 3.74731 14.1556 3.74731 13.6652V10.9269C3.74731 10.822 3.7754 10.7209 3.8278 10.6311C3.99064 10.3504 4.35188 10.255 4.63264 10.4197L10.813 14.0227C11.1743 14.2341 11.3971 14.6197 11.3971 15.039V17.8765C11.3971 18.0056 11.3615 18.1347 11.2941 18.2452C11.0901 18.5783 10.6559 18.6832 10.3227 18.4792L4.42302 14.8686ZM13.6357 9.66912C13.9969 9.88063 14.2196 10.2662 14.2196 10.6855V16.4428C14.2196 16.6132 14.1279 16.7703 13.98 16.8526L12.6269 17.6144C12.61 17.6238 12.5912 17.6313 12.5725 17.6369V14.4401C12.5725 14.0265 12.3554 13.6427 11.9998 13.4293L6.57175 10.1819V6.57333C6.57175 6.46852 6.59984 6.36745 6.65224 6.2776C6.81508 5.99684 7.17632 5.9014 7.45708 6.06609L13.6357 9.66912ZM16.3404 5.41662C16.7034 5.62625 16.9262 6.01557 16.9262 6.43483V14.8444C16.9262 15.0166 16.8307 15.1757 16.6791 15.258L15.397 15.9505V10.0959C15.397 9.68222 15.1798 9.3004 14.8261 9.08702L9.27828 5.75914V2.3358C9.27828 2.23099 9.30635 2.12991 9.35689 2.04008C9.51973 1.75932 9.88097 1.66387 10.1617 1.8267L16.3404 5.41662Z"
      fill="black"
    />
  </svg>
);
export default COMP;
